import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DialogService } from '@services/dialog/dialog.service';
import { PackageService } from '@services/packages/package.service';
import { CompositionService } from '@services/compositions/composition.service';
import { PackageInstalledAppsService } from '@services/packages/package-installed-apps.service';
import { PackageInstalledWidgetsService } from '@services/packages/package-installed-widgets.service';
import { DynamicContentEntranceService } from '@services/dynamic-content/dynamic-content-entrance.service';
import { DynamicContentService } from '@services/dynamic-content/dynamic-content.service';
import { ProductService } from '@services/products/product.service';
import { ImportService } from '@services/imports/import.service';
import { AccommodationWizardIdsService } from '@services/accommodation-wizard-ids-service/accommodation-wizard-ids.service';
import { Models } from '@ibexfusion/models';
import { ProfileService } from '@services/profiles/profile.service';
import { ProfileAppService } from '@services/profile-apps/profile-app.service';
import { AnalyticLogsService } from '@services/analytic-logs/analytic-logs.service';
import { Router } from '@angular/router';
import { SnackbarService } from '@services/snackbar/snackbar.service';
import { MessengerService } from '@services/messenger/messenger.service';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';

@Component({
    selector: 'app-package-eraser',
    templateUrl: './package-eraser.component.html',
    styleUrls: ['./package-eraser.component.scss'],
    providers: [
        DialogService, PackageService, CompositionService,
        PackageInstalledAppsService, PackageInstalledWidgetsService,
        DynamicContentEntranceService, DynamicContentService, ProductService,
        ImportService, AccommodationWizardIdsService,
        ProfileService, ProfileAppService, AnalyticLogsService
    ],
    standalone: false
})
export class PackageEraserComponent implements OnInit, OnDestroy {

  public title = '';

  public progressing = false;
  public done = false;
  public statusInfo = null;
  public error = null;
  public isTest = false;
  public type = null;
  public cancel = false;
  public protocol: any = {};
  public isLive: any;
  private apiKey = 'Vwvlo4aZMj|5Ht8g3WEoQ4W9mk6YpE16pP5lITtL8WS7R7ESbMC6rglHckoqFzMNL5j08Kq26Q1sx+xtyBNyDHT3RWEuf55Xw==';

  constructor(
    private router: Router, private snackbar: SnackbarService, public dialogRef: MatDialogRef<PackageEraserComponent>, public dialogService: DialogService,
    private packageService: PackageService, private compositionService: CompositionService, private dynamicContentEntranceService: DynamicContentEntranceService,
    private dynamicContentService: DynamicContentService, private productService: ProductService, private importService: ImportService,
    private accommodationWizardIdsService: AccommodationWizardIdsService, private profileService: ProfileService, private profileAppService: ProfileAppService,
    private analyticLogsService: AnalyticLogsService, private ms: MessengerService, private http: HttpClient, @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.isLive = this.ms.getActiveAPI() === 'live';
  }

  ngOnInit() {
    this.title = this.data && this.data.package ? this.data.package.title : '';
    if (!this.data || !this.data.package || !this.data.package.tweebie) {
      this.error = 'Package data is not valid';
      this.done = true;
    }
    if (this.data.package && this.data.package.tweebie && this.data.package.tweebie.isMaster) {
      this.error = 'Removing Master Package is not allowed';
      this.done = true;
    }
  }

  public ngOnDestroy() {
    this.cancel = true;
  }

  public onClose() {

    if (this.done && !this.isTest) {
      if (this.progressing) {
        this.snackbar.open('Still working, please wait!')
        return;
      }
      this.cancel = true;
      this.dialogRef.close();
      this.router.navigate(['packages']);
    } else {
      this.cancel = true;
      this.dialogRef.close();
    }
  }

  public onRemove(test = false) {
    this.isTest = test;
    this.initProtocol();
    if (this.isTest) {
      return this.removeAllData();
    }
    const random = this.generateRandom(4);
    this.dialogService.confirm(
      'Are you really sure to performe it?<br/> Enter the random code to confirm: ' + random,
      'Delete Package: ' + this.data.package.title,
      true).then(result => {
      if (result && result === random) {
        return this.removeAllData();
      } else {
        console.log('wrong random nummber');
      }
    });
  }

  public removeAllData(): Promise<boolean> {
    this.progressing = true;
    if (!this.isTest) {
      this.dialogRef.disableClose = true;
    }
    return this.removePackage().then(() => {
      this.protocol.log.push('Package removed');
      return this.removeCompositions().then(() => {
        this.protocol.log.push('Composition (' + this.protocol.compositionIds.length + ' of ' + this.data.compositions.length + ')');
        return this.removeDynamicContentEntrances().then(() => {
          this.protocol.log.push('Dynamic Entrances (' + this.protocol.dynamicContentEntranceIds.length + ')');
          this.statusInfo = 'Dynamic Content (' + this.protocol.dynamicContentIds.length + ')';
          return this.removeDynamicContent().then(() => {
            this.protocol.log.push('Dynamic Content (' + this.protocol.dynamicContentIds.length + ')');
            this.statusInfo = 'Imports (' + this.protocol.importIds.length + ')';
            return this.removeImports().then(() => {
              this.protocol.log.push('Imports (' + this.protocol.importIds.length + ')');
              this.statusInfo = 'Search analytics logs ...';
              return this.removeAnalyticLogs().then(() => {
                this.statusInfo = '';
                this.protocol.log.push('Analytic Logs (' + this.protocol.analyticLogsCount + ')');
                let promise;
                if (this.type === 'accommodation') {
                  this.statusInfo = 'Search profiles ...';
                  promise = this.removeAccommodationIdFromProfiles().then(() => {
                    this.protocol.log.push('tweebie accommodation profiles reset (' + this.protocol.tweebieAccommodationProfileCount + ')');
                    this.statusInfo = '';
                    return this.removeAccommodationIdFromProfileApps().then(() => {
                      this.protocol.log.push('tweebie accommodation profileApps removed (' + this.protocol.tweebieAccommodationProfileAppCount + ')');
                      return Promise.resolve(true);
                    })
                  });
                } else {
                  promise = Promise.resolve(true);
                }
                return promise.then(() => {
                  return this.saveProtocol().then(() => {
                    this.dialogRef.disableClose = false;
                    this.statusInfo = '(-: *** Success *** :-)';
                    this.progressing = false;
                    this.done = true;
                  });
                });
              });
            });
          });
        });
      });
    }).catch(err => {
      return this.saveProtocol(err);
    });
  }

  private removePackage(): Promise<any> {
    return this.removeByIds(this.packageService, [this.data.package._id], true);
  }

  private removeCompositions(): Promise<any> {
    if (!this.data.compositions || !this.data.compositions.length) {
      return Promise.resolve(true);
    }
    const promises = this.data.compositions.map(composition => {
      return this.find(this.packageService, { compositionIds: { $in: [composition._id] } }, 0, []).then(result => {
        let removeComposition = true;
        result.map(foundPackage => {
          if (!this.isTest || foundPackage._id !== this.data.package._id) {
            this.protocol.log.push(composition.title + ' not deleted - used by package: ' + foundPackage.title);
            removeComposition = false;
          }
        });
        if (removeComposition) {
          this.protocol.compositionIds.push(composition._id);
          this.protocol.dynamicContentEntranceIds = this.protocol.dynamicContentEntranceIds.concat(composition.dynamicContentIds || []);
          this.protocol.codeSnippetIds = this.protocol.codeSnippetIds.concat(composition.snippetIds || []);
          this.protocol.importIds = this.protocol.importIds.concat(composition.importIds || []);
        }
        return true;
      });
    });
    return Promise.all(promises).then(() => {
      return this.removeByIds(this.compositionService, this.protocol.compositionIds);
    });
  }

  private removeDynamicContentEntrances(): Promise<any> {
    if (!this.protocol.dynamicContentEntranceIds || !this.protocol.dynamicContentEntranceIds.length) {
      return Promise.resolve(true);
    }
    return this.find(this.dynamicContentEntranceService, { _id: { $in: this.protocol.dynamicContentEntranceIds } }, 0, [])
      .then(entrances => {
        entrances.map(entrance => {
          this.protocol.dynamicContentIds = this.protocol.dynamicContentIds.concat(entrance.children);
        });
        return this.removeByIds(this.dynamicContentEntranceService, this.protocol.dynamicContentEntranceIds);
      });
  }

  private removeDynamicContent(): Promise<any> {

    if (!this.protocol.dynamicContentIds || !this.protocol.dynamicContentIds.length) {
      return Promise.resolve(true);
    }
    return this.findAndRemoveDynamicContent(this.protocol.dynamicContentIds);
  }

  private removeImports(): Promise<any> {
    return this.removeByIds(this.importService, this.protocol.importIds);
  }

  private removeAnalyticLogs(): Promise<any> {
    let query: any = { customers: { $in: [this.data.package._id] } };
    if (this.type === 'screen') {
      query = { UUID: { $in: [this.data.package.screenUuids] } }
    }
    query = JSON.stringify(query);
    let params = '?query=' + encodeURIComponent(query);
    params += '&target=analytic-logs';
    params += '&api_key=' + encodeURIComponent(this.apiKey);
    return this.bulkRemoveByIds(this.analyticLogsService, params).then(result => {
      if (result && result.data) {
        this.protocol.analyticLogsCount = result.data.count;
      }
      return Promise.resolve(true);
    });
  }

  private removeAccommodationIdFromProfiles(): Promise<any> {
    return this.find(this.profileService, { currentAccommodationId: this.data.package._id }, 0, []).then(profiles => {
      this.statusInfo = 'Reset tweebie accommodation profiles (' + profiles.length + ')';
      const promises = profiles.map(profile => {
        profile.currentAccommodationId = null
        profile.currentAccommodationStayStart = null;
        profile.currentAccommodationStayEnd = null;
        this.protocol.tweebieAccommodationProfileCount++;
        if (this.isTest) {
          return true;
        }
        return this.profileService.update(profile.ProfileID, profile, { query: { updateSettings: true } }).catch(err => {
          const error = err && err.error && err.error.message ? err.error.message : err;
          this.protocol.log.push('Error on update profile ' + profile.ProfileID + ': ' + error);
          return Promise.resolve(true);
        })
      })
      return Promise.all(promises);
    });
  }

  private removeAccommodationIdFromProfileApps(): Promise<any> {
    return this.find(this.profileAppService, { accommodationId: this.data.package._id }, 0, []).then(profileApps => {
      this.statusInfo = 'Remving tweebie accommodation profileApps (' + profileApps.length + ')';
      const ids = [];
      const promises = profileApps.map(profileApp => {
        this.protocol.tweebieAccommodationProfileAppCount++;
        ids.push(profileApp.ProfileAppID); // is hashed here because changes on the model requires testing for the tweebie profile-apps
        return true;
      })
      return Promise.all(promises).then(() => {
        // return this.bulkRemoveByIds(this.profileAppService, ids, false, 'ProfileAppID');
        return this.removeByIds(this.profileAppService, ids, false);
      });
    });
  }

  /* helpers */

  private initProtocol() {
    this.protocol = {};
    this.statusInfo = null;
    this.error = null;
    this.protocol.title = this.title;
    this.protocol.type = 'package'
    this.protocol.isDeleted = true;
    this.protocol.initialData = this.data;
    this.protocol.log = [];
    this.protocol.dynamicContentEntranceIds = [];
    this.protocol.dynamicContentIds = [];
    this.protocol.productIds = [];
    this.protocol.codeSnippetIds = [];
    this.protocol.importIds = [];
    this.protocol.compositionIds = [];
    this.protocol.analyticLogsCount = 0;
    if (this.data.package.tweebie.isDestination) {
      this.type = 'destination';
    } else if (this.data.package.isScreenPackage) {
      this.type = 'screen';
    } else {
      this.type = 'accommodation';
      this.protocol.tweebieAccommodationProfileCount = 0;
      this.protocol.tweebieAccommodationProfileAppCount = 0;
    }
  }

  private find(service, query, skip, documents): Promise<any> {
    if (this.cancel) {
      throw new Error('canceled');
    }
    let limit = 100;
    if (service.provider.endpointName === 'analytic-logs') {
      limit = 1000000
    }
    return service.find(skip, limit, query).then(result => {
      if (result && result.data && result.data.length) {
        documents = documents.concat(result.data);
        if (result.total - skip > limit) {
          return this.find(service, query, skip + limit, documents);
        }
      }
      return Promise.resolve(documents);
    });
  }

  private findAndRemoveDynamicContent(ids): Promise<any> {

    return this.find(this.dynamicContentService, { _id: { $in: ids } }, 0, []).then(documents => {
      const promises = documents.map(document => {
        ids = ids.concat(document.translationEntries || []);
        this.protocol.dynamicContentIds = this.protocol.dynamicContentIds.concat(document.translationEntries || []);
        if (document.content && document.content.products) {
          this.protocol.productIds.push(document.content.products);
          this.removeByIds(this.productService, [document.content.products]);
        }
        if (document.children && document.children.length) {
          this.protocol.dynamicContentIds = this.protocol.dynamicContentIds.concat(document.children);
          return this.findAndRemoveDynamicContent(document.children);
        }
      });
      return Promise.all(promises).then(() => {
        return this.removeByIds(this.dynamicContentService, ids);
      });
    })
  }

  private removeByIds(service, ids, bubbleError = false): Promise<any> {
    if (this.cancel) {
      throw new Error('canceled');
    }
    const promises = ids.map(id => {
      if (this.cancel) {
        throw new Error('canceled');
      }
      if (this.isTest) {
        return service.get(id).catch(err => {
          const error = err && err.error && err.error.message ? err.error.message : err;
          this.protocol.log.push('not found: ' + service.provider.endpointName + ', ' + id + ': ' + error);
          return Promise.resolve(true);
        });
      } else {
        if (bubbleError) {
          return service.remove(id);
        }
        return service.remove(id).catch(err => {
          console.log(err);
          const error = err && err.error && err.error.message ? err.error.message : err;
          this.protocol.log.push('removing: ' + service.provider.endpointName + ', ' + id + ': ' + error);
          return Promise.resolve(true);
        });
      }
    });
    return Promise.all(promises);
  }

  private bulkRemoveByIds(service, params): Promise<any> {
    let backendUrl = environment.apiBaseURL;
    if (this.ms.getActiveAPI() === 'live' || this.ms.getActiveAPI() === 'staging') {
      backendUrl = environment[this.ms.getActiveAPI()].apiBaseURL;
    }
    if (this.cancel) {
      throw new Error('canceled');
    }
    if (this.isTest) {
      return this.http.get(backendUrl + '/bulkRemove' + params).toPromise().then(result => {
        return result;
      }).catch(err => {
        const error = err && err.error && err.error.message ? err.error.message : err;
        this.protocol.log.push('error on bulk-finding: ' + service.provider.endpointName + ': ' + error);
        return Promise.resolve(true);
      });
    } else {
      return this.http.delete(backendUrl + '/bulkRemove' + params).toPromise().then(result => {
        return result;
      }).catch(err => {
        const error = err && err.error && err.error.message ? err.error.message : err;
        this.protocol.log.push('error on bulk-remvoe: ' + service.provider.endpointName + ': ' + error);
        return Promise.resolve(true);
      });
    }
  }

  private generateRandom(amount) {
    const code = [];
    for (let i = 0; i < amount; i++) {
      code.push(Math.floor(Math.random() * 10));
    }
    return code.join('');
  }

  private saveProtocol(error = null): Promise<any> {
    if (error) {
      this.error = error && error.error && error.error.message ? error.error.message : error;
      this.protocol.errror = error;
    } else {
      this.protocol.success = true;
    }
    const protocol = new Models.AccommodationWizardIds();
    protocol.processedData = this.protocol;
    if (this.isTest) {
      console.log(this.protocol)
      return Promise.resolve(true);
    }
    return this.accommodationWizardIdsService.create(protocol).then(result => {
      console.log('wrote data: ', result);
      this.snackbar.open('protocol saved to wizard data (you find this under userManagement)')
      return Promise.resolve(true);
    });
  }

}
